import type { SalesByCategoryReport } from 'model/SalesByCategoryReport';
export type Slice = { name: string; value: number; percentage: number; color: string };

const COLORS = ['#BDD2CA', '#92B4A7', '#5E8677', '#BAA997', '#DCCCBB', '#EAB464', '#D5E1DB'];
const round2 = (n: number) => Math.round(n * 100) / 100;

const KEY_TO_COLOR: Record<string, string> = {
    grooming: '#5E8677',
    daycare: '#92B4A7',
    boarding: '#BDD2CA',
    addons: '#BAA997',
    products: '#DCCCBB',
    custom_items: '#EAB464',
    services: '#5E8677'
};

const resolveColor = (key: string, idx: number) => KEY_TO_COLOR[key] ?? COLORS[idx % COLORS.length];

export const mapSalesByCategoryToSlices = (
    report: SalesByCategoryReport | null,
    valueKey: 'quantity' | 'netSales'
): { data: Slice[]; total: number } => {
    const categories = report?.categories ?? [];
    if (!categories.length) return { data: [], total: 0 };

    const rows = categories.filter(c => {
        const v = valueKey === 'quantity' ? c.quantity : c.netSales;
        return (v ?? 0) > 0;
    });

    const total = rows.reduce((sum, c) => sum + (valueKey === 'quantity' ? c.quantity : c.netSales), 0);

    const data: Slice[] = rows.map((c, idx) => {
        const value = valueKey === 'quantity' ? c.quantity : c.netSales;
        const percentage = total > 0 ? round2((value / total) * 100) : 0;

        return {
            name: c.label || c.key,
            value,
            percentage,
            color: resolveColor(c.key, idx)
        };
    });

    return { data, total };
};
